module.exports = __webpack_public_path__ + "static/media/light_fixture_console_park_dnat.dda06b14.png";